import { BaseControl } from "../base-control";

class NotFoundCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
  async $onInit(){
    await super.$onInit();
    this.notFoundLabel = this.token.control?.type || 'MISSING!';
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/not-found/not-found.component.html",
  controller: NotFoundCtrl
};